import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { ModalService } from '../../modal.service';
import { MessageBusService } from '@xdig/ng-microkernel/micro-frontend';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ErrorRendered } from '@core/types/error.type';
import { UnHappyPathModal } from '@core/layouts/default/default.config';
import { PROJECT_TYPE } from '@core/types/projects.type';
import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';
import { IDLE_TIMEOUT_CONFIG, PROJECT_NAME_BY_TYPE } from './idle-timeout.component.config';

@Component({
  selector: 'shell-idle-timeout',
  templateUrl: './idle-timeout.component.html',
  styleUrls: ['./idle-timeout.component.scss'],
})
export class IdleTimeoutComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private idleComponent: ErrorRendered = 'IDLE_TIMEOUT';
  project: PROJECT_TYPE;
  config: ModalErrorConfig;
  timeLeft: string;

  constructor(
    private modalService: ModalService,
    public messageBus: MessageBusService,
    public ngZone: NgZone,
  ) {}

  ngOnInit(): void {
    this.onToTimeOut();
  }

  closeModal(): void {
    this.emitGTMIdleTimeOutCloseModal();
    this.messageBus.emit(PROJECT_NAME_BY_TYPE.get(this.project) as string, 'modal.error', {
      component: this.idleComponent,
      payload: { returned: true },
    });

    this.modalService.close();
  }
  emitGTMIdleTimeOutCloseModal() {
    const modalError: any = this.messageBus.getValue('shell', 'modal.error') || {
      gtm: '',
      savingAccountName: '',
    };
    if (modalError.gtm === UnHappyPathModal.IDLE_TIMEOUT_MODAL) {
      this.messageBus.emit('shell', 'google-tag-manager.event', {
        event: 'button-event',
        eventCategory: 'Complementos',
        eventAction: 'Sigues ahi',
        eventLabel: `He vuelto - ${modalError.savingAccountName}`,
      });
    }
  }

  onToTimeOut(): void {
    this.messageBus
      .on$<any>('shell', 'modal.error')
      .pipe(
        takeUntil(this.destroy$),
        filter(({ component }) => component === this.idleComponent),
        tap(({ payload }) => {
          this.ngZone.run(() => {
            this.timeLeft = payload.timeLeft;
            this.project = payload.project as PROJECT_TYPE;
            this.config = IDLE_TIMEOUT_CONFIG.get(this.project) as ModalErrorConfig;
          });
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
